<template>
  <div id="verification-view">
    
    <div
      class="modal fade bd-example-modal-lg no-close-on-backdrop" 
      id="verificationModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      ref="vuemodal"
      backdrop="false"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body custom-modal-body">
        
           
              <button type="button" @click="resetLoader()" class="close" data-dismiss="modal"  aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="form-title text-center">
                <h4 class="pt-3 mb-0">Please verify your Email </h4>
              </div>
            
              <div class="d-flex flex-column text-center">
                   
              <b-overlay :show="loader" rounded="sm">
                <form >
            
                  <div class="form-group" >
                    <input
                      type="email"
                      class="form-control"
                      v-model="email"
                      placeholder="Your email address..."
                    />
                       <span class="text-danger" v-if="errors.email">{{
                            this.errors.email[0]
                            }}</span></br>
                     <button
                    type="button"
                    class="btn btn-secondary btn-round col-md-8 mt-2"
                  
                    @click="verifyemail()"
                  >
                Send Otp
                  </button>
                  </div>
                
                </form>
              </b-overlay>
             
 <b-modal id="sms-modal" centered title="" size="mb">
      <section
        class="mx-3"
        style="max-height: 280px;"
      >
       <p>Enter Otp<p/>
         <input
                            type="text"
                            class="form-control"
                            v-model="otp"
                            placeholder="Enter OTP"
                          />
      </section>
      <template #modal-footer="{ ok }">
        <button class="btn btn-primary my-4 col-md-12" @click="checkOtp(otp)">
          ok
        </button>
      </template>
    </b-modal>

              
            </div>
          
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SignupView from "@/views/site/SignupView";
export default {
  name: "VerifivcationView",
  components: {
  
    SignupView,
   
  },
   data() {
    return {
      email: null,
      otp:null,
      loader:false,
      errors:[],
     
    
    };

  },
  methods: {
   resetLoader() {
      this.loader = false;
    },
   verifyemail(){
      this.errors = [];
      this.error_msg = null;
      this.loader = true;
      let apiUrl = process.env.VUE_APP_URL + "customer/verifyEmail";
      let method_type = "post";
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          email: this.email,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === true) {
              this.loader = false;
            
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire("Good to Go", data.message, "success");
               $("#verificationModal").modal("hide")
               this.$bvModal.show("sms-modal");
            
            
          } else if (data.status === false && data.message != null) {
            localStorage.clear();
            this.loader = false;
            this.error_msg = data.message;
          } else {
            this.loader = false;
            this.errors = data.errors;
          }
        })
        .catch(function (err) {
          console.log("User Data", "Error : " + err.message, "error");
        });

   },
   checkOtp(otp){
     console.log(otp);
     console.log(this.email);
     this.errors = [];
      this.loader = true;
      let apiUrl = process.env.VUE_APP_URL + "customer/verifyotpPin";
      let method_type = "post";
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          otp: otp,
          email:this.email,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
         // this.loader = false;
          if (data.status === true) {
           
            this.loader = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire("Good to Go", data.message, "success");
              this.$bvModal.hide("sms-modal");
              this.ShowForm();
            
          }
          if (data.status === false) {
            this.$swal("Error", data.message, "error");
          } else {
            this.loader = false;
            this.errors = data.errors;
          }
        })
        .catch(function (err) {
          console.log("Register Data", "Error : " + err.message, "error");
        });

     },

    ShowForm() {
      this.$emit("VerifySignup", this.email);

    },

 
   
    
  },
};
</script>
<style scoped>
.scroll-area {
  position: relative;
  margin: auto;
  min-height: 76vh;
  max-height: 85vh;
}
</style>
